import { Pipe, PipeTransform } from '@angular/core';

import { Formatters } from 'app/slick-grid/models/formatters';

@Pipe({
    name: 'numeral'
})
export class NumeralPipe implements PipeTransform {
    transform(value: number, decimalPlaces?: number): string {
        return Formatters.numberFormatter(null, null, value, decimalPlaces == null ? 2 : decimalPlaces);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/numeral.pipe.ts